/*
xs, extra-small: 0px
sm, small: 600px
md, medium: 900px
lg, large: 1200px
xl, extra-large: 1536px
*/

import React, { useContext, useEffect, useState } from 'react'
import { Container, Grid, IconButton, Paper, Typography } from '@mui/material'
import { ContextoGlobal, ContextoGlobalInterface } from '../../../GlobalStates/ContextoGlobal'
import Button from '@mui/material/Button'
import CloseIcon from '@mui/icons-material/Close'

import DataTable, { DataTableCabecalhoInterface } from '../../../DevComponents/DataTable'
import { useNavigate } from 'react-router-dom'
import BackEndAPI from '../../../Services/BackEndAPI'
import ExibirJSONDev from '../../../DevComponents/ExibirJSONDev'
import { EMDESENVOLVIMENTO } from '../../../ImportBackend/Config/emDesenvolvimento'
import { OrdemServicoInterface } from '../../../ImportBackend/Interfaces/OrdemServicoInterfaces'
import PesquisarTabela from '../../../DevComponents/PesquisarTabela'
import { MaterialInterface } from '../../../ImportBackend/Interfaces/MaterialInterfaces'
import { FilialInterface } from '../../../ImportBackend/Interfaces/FilialInterfaces'
import ClsFormatacao from '../../../Utils/ClsFormatacao'
import { RespostaPadraoInterface } from '../../../ImportBackend/Interfaces/PadraoInterfaces'

interface rsFilialPesquisaInterface {
  idFilial: number
  idMaterial: number
}

export default function RecebimentoAmostras () {

  const clsFormatacao: ClsFormatacao = new ClsFormatacao()

  const navigate = useNavigate()

  const contexto = useContext( ContextoGlobal ) as ContextoGlobalInterface

  const clsApi = new BackEndAPI()

  const [pesquisa, setPesquisa] = useState<rsFilialPesquisaInterface>( {
    idFilial: 0,
    idMaterial: 0
  } )

  const [rsOrdensServicos, setRsOrdensServicos] = useState<Array<OrdemServicoInterface>>( [] )

  const btFechar = () => {
    navigate( '/' )
  }

  const cabecalho: Array<DataTableCabecalhoInterface> = [
    {
      campo: 'idOrdemServico',
      cabecalho: 'OS',
      alinhamento: 'left',
    },
    {
      campo: 'qtdAmostras',
      cabecalho: 'Amostras',
      alinhamento: 'right',
    },
    {
      campo: 'Filial',
      cabecalho: 'Filial',
      alinhamento: 'left',
      format: ( rs: FilialInterface ) => rs.descricao
    },
    {
      campo: 'createdAt',
      cabecalho: 'Data OS',
      alinhamento: 'left',
      format: ( rs: string ) => clsFormatacao.dataFromIsoUTC( rs )
    },
  ]

  const cabecalhoGrupo: Array<DataTableCabecalhoInterface> = [
    {
      campo: 'idLote',
      cabecalho: 'Lote',
      alinhamento: 'left',
    },
    {
      campo: 'Material',
      cabecalho: 'Material',
      alinhamento: 'left',
      format: ( rs: MaterialInterface ) => rs.descricao
    },
    {
      campo: 'qtdAmostras',
      cabecalho: 'Amostras',
      alinhamento: 'right',
    }
  ]

  const pesquisarAmostrasEmTransito = () => {
    const query = `
      getAmostrasEmTransito(idFilial: ${pesquisa.idFilial}, idMaterial: ${pesquisa.idMaterial})
    `

    clsApi.query<Array<OrdemServicoInterface>>( query, 'getAmostrasEmTransito', 'Pesquisando Amostras em Transito...', contexto ).then( rs => {
      setRsOrdensServicos( rs )
    } )

  }

  useEffect( () => {

    pesquisarAmostrasEmTransito()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [] )

  const btReceberAmostras = ( rs: OrdemServicoInterface, indice: number ) => {

    const mutation = `
      receberAmostrasOS(idOrdemServico: ${rs.idOrdemServico}) {
        ok
        mensagem
      }
    `

    clsApi.mutation<RespostaPadraoInterface>( mutation, 'receberAmostrasOS', 'Atualizando Status das Amostras...', contexto ).then( rs => {

      if ( rs.ok ) {

        setRsOrdensServicos( rsOrdensServicos.filter( ( _, i ) => i !== indice ) )

      } else {

        contexto.setMensagemState( {
          tipo: 'error',
          mensagem: rs.mensagem,
          cb: null,
          exibir: true,
          exibirBotao: true,
          titulo: 'Erro ao Atualizar Amostras....'
        } )

      }

    } )

  }

  return (
    <>

      <Container maxWidth="lg" sx={{ mt: 5 }}>

        <Paper variant="outlined" sx={{ padding: 2 }}>
          <Grid container sx={{ display: 'flex', alignItems: 'stretch' }}>

            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
              <Typography component="h5" variant="h5" align="left">
                Recebimento de Amostras
                <Typography variant="body2" gutterBottom>
                  Recebimento de Amostras enviadas pelas unidades
                </Typography>
              </Typography>

              <IconButton onClick={() => btFechar()}>
                <CloseIcon />
              </IconButton>
            </Grid>

            <Grid item xs={12} md={6}>

              <PesquisarTabela<FilialInterface>
                setState={setPesquisa}
                field='idFilial'
                fieldSet='idFilial'
                label='Filial'
                dados={pesquisa}
                campoQueryPesquisaID='idFilial'
                campoQueryPesquisa='pesquisa'
                camposRetornoQueryPesquisa='{idFilial, descricao}'
                campoLabelQueryPesquisa='descricao'
                nomeQueryPesquisa='getFiliais'
                nomeQueryPesquisaID='getFilialPorId'
                mensagemPesquisa='Procurando Filiais...'
                pesquisarTudoAoIniciar
                valorAtribuirLimpar={0}
              />

            </Grid>

            <Grid item xs={12} md={6} sx={{ pl: { md: 1 } }}>

              <PesquisarTabela<MaterialInterface>
                setState={setPesquisa}
                field='idMaterial'
                fieldSet='idMaterial'
                label='Material'
                dados={pesquisa}
                campoQueryPesquisaID='idMaterial'
                campoQueryPesquisa='pesquisa'
                camposRetornoQueryPesquisa='{idMaterial, descricao}'
                campoLabelQueryPesquisa='descricao'
                nomeQueryPesquisa='getMateriais'
                nomeQueryPesquisaID='getMaterialPorId'
                mensagemPesquisa='Procurando Materiais...'
                pesquisarTudoAoIniciar
                valorAtribuirLimpar={0}
              />

            </Grid>

            <Grid textAlign='right' item xs={12} sx={{ mt: 4.5, textAlign: 'right' }}>
              <Button variant='contained' onClick={() => pesquisarAmostrasEmTransito()} >Pesquisar</Button>
            </Grid>

            <Grid item xs={12} sx={{ mt: 4.5 }}>
              <DataTable
                cabecalho={cabecalho}
                dados={rsOrdensServicos}
                campoGrupo='Lotes'
                cabecalhoGrupo={cabecalhoGrupo}
                acoes={[
                  { icone: 'move_to_inbox_outlined', toolTip: 'Sinalizar Recebimento', onAcionador: ( rs: OrdemServicoInterface, indice: number ) => btReceberAmostras( rs, indice ) }
                ]}

              />
            </Grid>


            <ExibirJSONDev exibir={EMDESENVOLVIMENTO} oque={['rsOrdensServicos', rsOrdensServicos]} />

          </Grid>

        </Paper>

      </Container >
    </>
  )
}